import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { autoDismiss: { type: Number, default: 5000 } }

  connect() {
    if (this.autoDismissValue > 0) {
      this.timeout = setTimeout(() => this.dismiss(), this.autoDismissValue)
    }
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  dismiss() {
    this.element.style.maxHeight = this.element.offsetHeight + "px"
    this.element.offsetHeight // Force reflow
    this.element.style.maxHeight = "0"
    this.element.style.padding = "0"
    this.element.style.opacity = "0"

    setTimeout(() => this.element.remove(), 300)
  }
}
